import { createMuiTheme } from "@material-ui/core/styles";
import { deepPurple } from "@material-ui/core/colors";
import indigo from "@material-ui/core/colors/indigo";
import pink from "@material-ui/core/colors/pink";
import red from "@material-ui/core/colors/red";
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ED4E2A",
    },
    secondary: {
      main: "#fff",
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});

export default theme;
